import { getAttributeInfo } from '../../../Model/avenyModelUtils';
import { IClientBusinessModel } from '../../../Types/ClientModelTypes';
import { AvenyCollectionMap } from '../../../Model/ModelContext/ModelContext';
import { findFormatter } from '../../../Utils/Formatters/FindFormatter';
import { ValueType } from '../../../Utils/Formatters/FormatterTypes';

export const attributeValueNoLineBreak = (
  collectionName: string | IClientBusinessModel,
  attributePath: string,
  collectionMap: AvenyCollectionMap
): boolean => {
  const attributeModel = getAttributeInfo(
    collectionName,
    attributePath,
    collectionMap
  ).attribute;

  return (
    attributeModel.DataType !== 'String' ||
    (attributeModel.MaxInputLength != null &&
      attributeModel.MaxInputLength < 20)
  );
};

export const attributeValueDisplayText = (
  collectionName: string | IClientBusinessModel,
  attributePath: string,
  collectionMap: AvenyCollectionMap,
  value: ValueType
): string => {
  const attributeModel = getAttributeInfo(
    collectionName,
    attributePath,
    collectionMap
  ).attribute;
  const formatter = findFormatter(
    attributeModel.Formatter,
    attributeModel.DataType
  );
  return (
    formatter.displayer.display(
      value,
      true,
      attributeModel.FormatterDisplayParams
    ) || '—'
  );
};
